import { PractitionerRole } from '@common/enums/practitionerRole';
import { sleep } from '@common/utils/sleep';
import { changeToEmployment as changeToEmploymentApi } from '@frontend/services/api/employmentsApiService';
import { window } from '@frontend/utils/window';

export async function changeToEmployment(
    employmentId: string,
    abortSignal: AbortSignal,
    employmentChangedCallback?: () => void | Promise<void>
) {
    /*
    FIXME:
    Wait for 1 second to fix (in most cases) the issue that the session is reset and the user is logged out when a long
    running request is returning after the employment is changed.
      spike to fix this: CS-10405
  */
    await sleep(1000);

    if (employmentChangedCallback) {
        await changeToEmploymentApi(employmentId, abortSignal);

        await employmentChangedCallback();
    } else {
        const employment = await changeToEmploymentApi(employmentId, abortSignal);

        const isOnlyOrganizationPayoutManager =
            !employment.hasEmploymentRights &&
            !!employment.employmentPractitionerRoles?.find(
                (employmentRole: PractitionerRole) => employmentRole === PractitionerRole.organizationPayoutManager
            );

        if (isOnlyOrganizationPayoutManager) {
            window.redirect('/home');
        } else {
            window.reload();
        }
    }
}
